<template>
    <footer class="footer uk-padding-small">
        <div class="uk-container uk-container-expand">
            <ul>
                <li class="uk-visible@s">
                    &copy; {{ currentYear }} Simonds Group Limited - CDB-U 49491
                </li>
                <li>
                    version: {{ versionNumber }}
                </li>
            </ul>
            <p class="copyright uk-hidden@s">
                &copy; {{ currentYear }} Simonds Group Limited - CDB-U 49491
            </p>
        </div>
    </footer>
</template>
<script>
import config from '../../helpers/config'

export default {
    computed: {
        versionNumber: function () {
            return config.appVersion
        },
        currentYear: function () {
            return new Date().getFullYear();
        }
    }
}
</script>
